import React, { useEffect, useRef, useState } from 'react';

const TrustedCompanies = () => {
  // Companies data array
  const companies = [
    {
      id: 1,
      name: 'Webfymedia',
      logo: '../assets/images/migration/logo-webfymedia.png',
      url: '#',
      hasHoverOpacity: true
    },
    {
      id: 2,
      name: 'Village',
      logo: '../assets/images/migration/25698.png',
      url: '#',
      hasHoverOpacity: true
    },
    {
      id: 3,
      name: 'Bindusar yoga',
      logo: '../assets/images/migration/abco.png',
      url: '#',
      hasHoverOpacity: true
    },
    {
      id: 4,
      name: 'oendigi-logo',
      logo: '../assets/images/migration/oendigi-logo.png',
      url: '#',
      hasHoverOpacity: false
    },
    {
      id: 5,
      name: 'AFE',
      logo: '../assets/images/migration/AFElogo-white.SVG',
      url: '#',
      hasHoverOpacity: true
    },
    {
      id: 6,
      name: 'skrollex',
      logo: '../assets/images/migration/skrollex_logo.PNG',
      url: '#',
      hasHoverOpacity: false
    },
    {
      id: 7,
      name: 'LOGO-E-and-J-International-Art-Gallery',
      logo: '../assets/images/migration/LOGO-E-and-J-International-Art-Gallery.png',
      url: '#',
      hasHoverOpacity: true
    },
    {
      id: 8,
      name: 'TRY',
      logo: '../assets/images/migration/try.png',
      url: '#',
      hasHoverOpacity: false
    },
    {
      id: 9,
      name: 'Golem.de',
      logo: '../assets/images/migration/clicklogos.png',
      url: '#',
      hasHoverOpacity: true
    }
  ];

  const sliderRef = useRef(null);
  const animationRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  // Single company logo component
  const CompanyLogo = ({ company }) => (
    <li 
      className="flex-none mr-[var(--logoloop-gap)] text-[length:var(--logoloop-logoHeight)] leading-[1] overflow-visible group/item" 
      role="listitem"
    >
      <a 
        className="inline-flex items-center no-underline rounded transition-opacity duration-200 ease-linear hover:opacity-80 focus-visible:outline focus-visible:outline-current focus-visible:outline-offset-2" 
        href={company.url} 
        aria-label={company.name} 
        target="_blank" 
        rel="noreferrer noopener"
      >
        <img 
          className={`h-[24px] w-auto block object-contain [-webkit-user-drag:none] pointer-events-none transition-transform duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] group-hover/item:scale-110 ${company.hasHoverOpacity ? 'hover:opacity-100' : ''}`}
          src={company.logo} 
          alt={company.name} 
          title={company.name} 
          loading="lazy" 
          decoding="async" 
          draggable="false"
          style={{ filter: 'brightness(0) invert(0.4)' }} // This creates gray-800 color effect
        />
      </a>
    </li>
  );

  // Create triple array for infinite scrolling
  const infiniteCompanies = [...companies, ...companies, ...companies];

  // Auto-scroll animation
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let scrollPosition = 0;
    const speed = 0.8; // Scroll speed (adjust as needed)
    
    // Calculate width of one set
    const getSetWidth = () => {
      const firstSet = slider.children[0];
      return firstSet ? firstSet.offsetWidth : 0;
    };

    const animate = () => {
      if (!isHovered) {
        scrollPosition -= speed;
        
        // Reset when one full set has scrolled
        const setWidth = getSetWidth();
        if (Math.abs(scrollPosition) >= setWidth) {
          scrollPosition = 0;
        }
        
        if (slider) {
          slider.style.transform = `translate3d(${scrollPosition}px, 0px, 0px)`;
        }
      }
      
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    // Cleanup
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isHovered]);

  return (
    <div 
      className="mt-10 transition-all duration-700 delay-500 opacity-100 translate-y-0"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <p className="text-xs text-gray-800 font-medium uppercase tracking-wider mb-3 text-center">
        Businesses Worldwide Trust AyanshTech Solutions
      </p>
      
      <div className="w-full max-w-3xl mx-auto overflow-hidden">
        <div 
          className="relative overflow-x-hidden group [--logoloop-gap:32px] [--logoloop-logoHeight:28px] [--logoloop-fadeColorAuto:#ffffff] dark:[--logoloop-fadeColorAuto:#0b0b0b] py-[calc(var(--logoloop-logoHeight)*0.1)] py-2"
          role="region" 
          aria-label="Customer reference logos"
        >
          <div 
            ref={sliderRef}
            className="flex w-max will-change-transform select-none motion-reduce:transform-none"
            style={{ transform: 'translate3d(0px, 0px, 0px)' }}
          >
            <ul className="flex items-center" role="list" aria-hidden="false">
              {infiniteCompanies.map((company, index) => (
                <CompanyLogo key={`${company.id}-${index}`} company={company} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedCompanies;